import { render, staticRenderFns } from "./FileUploadPWP.vue?vue&type=template&id=5bfef4de&scoped=true"
import script from "./FileUploadPWP.vue?vue&type=script&lang=js"
export * from "./FileUploadPWP.vue?vue&type=script&lang=js"
import style0 from "./FileUploadPWP.vue?vue&type=style&index=0&id=5bfef4de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfef4de",
  null
  
)

export default component.exports